import { sub, parseISO } from "date-fns"
import UAIStatsCohorte from "./UAIStatsCohorte"
import UAI from "../UAI"
import log from "loglevel"
/**
 *
 **/
class UAIStats {
  static valorUF = 32216
  static valorUSD = 850
  fecha = null
  periodo = 0
  periodoant = 0
  cohortes = []
  descartados = []
  totalFacultad = {}
  totalUnidadventa = {}
  totalUVF = {}
  totalUAI = {
    Stats: new UAIStatsCohorte(null, null),
    StatsLw: new UAIStatsCohorte(null, null),
    StatsPrev: new UAIStatsCohorte(null, null),
  }
  rawdata = null
  nombrescortos = []

  estadisticaVacia(cohorte) {
    return {
      Stats: new UAIStatsCohorte(cohorte, null),
      StatsLw: new UAIStatsCohorte(cohorte, null),
      StatsPrev: new UAIStatsCohorte(cohorte, null, true),
    }
  }

  constructor(obj) {
    obj && Object.assign(this, obj)
  }

  initalize(_stats, _usuario, callbackProgress) {
    // Valida que parámetros de entrada no sean nulos o undefined
    if (!_stats || !_usuario || !Array.isArray(_stats)) {
      throw new Error(
        "Parámetros inválidos para calcular estadísticas de cohortes"
      )
    }

    if (_stats.length === 0) {
      log.debug(_stats)
      log.warn("Estadísticas vacías entregadas para cálculos")
    }

    // Guarda período y período anterior en el objeto
    this.periodo = _usuario.periodo
    this.periodoant = _usuario.periodo - 1
    this.fecha = _usuario.fechaReporte
    this.rawdata = _stats

    // Hash de cohortes
    let cohortesinfo = {}

    log.debug("Procesando " + _stats.length + " estadísticas")

    // Inicializar rawstats de cada cohorte
    _stats.forEach((_cohortestat) => {
      let cohorte = _usuario.cohortes[_cohortestat.CohorteId]
      // No debería existir una estadística sin su correspondiente cohorte
      if (!cohorte) {
        log.error(_cohortestat)
        throw new Error(
          "Cohorte con stats pero inexistente para el usuario! Acceso denegado:" +
            _cohortestat.CohorteId
        )
      }
      cohorte.rawstats = cohorte.rawstats || {}
      // Obtenemos la fecha de la estadística como objeto js
      let fechaestadistica = new Date(Date.parse(_cohortestat.Fecha))
      cohorte.rawstats[UAI.formatoFechaYMD(fechaestadistica)] = _cohortestat
    })

    // Avisamos que llevamos un 10% de progreso
    if (typeof callbackProgress === "function") {
      callbackProgress(10)
    }

    let cohortesSinEstadisticas = []
    Object.values(_usuario.cohortes).forEach((cohorte) => {
      // Ignorar los cohortes fuera del período actual y el anterior
      if (
        cohorte.año_inicio > this.periodo ||
        cohorte.año_inicio < this.periodoant
      ) {
        return
      }
      // Borradores no pueden tener estadísticas porque ni siquiera se han creado
      if (cohorte.esborrador) {
        return
      }
      if (cohorte.rawstats === undefined || cohorte.rawstats === null) {
        cohortesSinEstadisticas.push(cohorte.id + " - " + cohorte.sigla)
        return
      }
      // Si el cohorte es del período anterior, las fechas de hoy y la semana pasada coinciden, porque no hay más registros
      // después de cierta fecha (cuando el cohorte es deshabilitado). Guardamos el primero en statsprev.
      if (!cohorte.Periodo) {
        cohorte.statsprev = Object.values(cohorte.rawstats)[0]
      } else {
        // En este caso el cohorte es del período
        if (cohorte.rawstats && Object.values(cohorte.rawstats).length === 1) {
          // Si tenemos una sola estadística, la copiamos en la actual y de la semana pasada, para que no haya diferencias
          cohorte.stats = Object.values(cohorte.rawstats)[0]
          cohorte.statslw = Object.values(cohorte.rawstats)[0]
        } else if (
          cohorte.rawstats &&
          Object.values(cohorte.rawstats).length > 1
        ) {
          // Si tenemos dos estadísticas, nos aseguramos de ordenarlas correctamente y se guardan
          // Ordenar alfabéticamente las llaves, de tal forma que queden las estadísticas más recientes (hoy y hace una semana) primero
          let keys = Object.keys(cohorte.rawstats)
          keys.sort((a, b) => {
            return b.localeCompare(a)
          })
          let key1 = keys[0]
          let key2 = keys[1]
          if (key1.localeCompare(key2) > 0) {
            cohorte.stats = cohorte.rawstats[key1]
            cohorte.statslw = cohorte.rawstats[key2]
          } else {
            cohorte.stats = cohorte.rawstats[key2]
            cohorte.statslw = cohorte.rawstats[key1]
          }
        } else {
          console.log(cohorte)
          throw new Error(
            "No deberíamos tener más de dos estadísticas por cohorte!"
          )
        }
      }

      if (this.descartarCohorte(cohorte, _usuario)) {
        this.descartados.push({
          cohorte: cohorte,
          dictado: cohorte.dictado,
          año: cohorte.año_inicio,
        })
        return
      }

      cohortesinfo[cohorte.id] = cohorte
    })

    // Llevamos un 20% de progreso
    if (typeof callbackProgress === "function") {
      callbackProgress(20)
    }

    if (cohortesSinEstadisticas.length > 0) {
      log.debug("Cohortes sin estadísticas")
      log.debug(cohortesSinEstadisticas)
    }

    // Llevamos un 50% de progreso
    if (typeof callbackProgress === "function") {
      callbackProgress(50)
    }

    // Acá hacemos la separación de los benchmarks
    for (let idxii in cohortesinfo) {
      let cohorte = cohortesinfo[idxii]
      let facultad = UAI.obtieneFacultadPorId(cohorte.facultad_id)
      if (!facultad) {
        console.log(
          "Cohorte no pertenece a ninguna facultad válida!" +
            cohorte.id +
            " - " +
            cohorte.sigla +
            " - " +
            cohorte.nombre
        )
        continue
      }
      // Si tenemos stats para el cohorte (y de la última semana)
      if (cohorte.stats !== undefined && cohorte.statslw !== undefined) {
        cohorte.Stats = new UAIStatsCohorte(cohorte, cohorte.stats, false)
        cohorte.StatsLw = new UAIStatsCohorte(cohorte, cohorte.statslw, false)
      }
      // Si el cohorte es actual y tiene Benchmark, asignamos en statprev los stats del benchmark
      if (cohorte.Periodo && cohorte.programaid_anterior > 0) {
        if (cohorte.benchmarkinfo === undefined) {
          console.log(
            "Cohorte " +
              cohorte.id +
              " sin información de su benchmark! " +
              cohorte.programaid_anterior
          )
          cohorte.StatsPrev = new UAIStatsCohorte(null, null, false)
          cohorte.StatsPrev.benchmarkError = true
        } else {
          cohorte.StatsPrev = new UAIStatsCohorte(
            cohorte.benchmarkinfo,
            cohorte.benchmarkinfo.statsprev,
            false
          )
        }
      }
      // Si el cohorte es antiguo pero no es benchmark, lo sumamos igual
      if (!cohorte.Periodo && !cohorte.esBenchmark) {
        cohorte.StatsPrev = new UAIStatsCohorte(
          cohorte,
          cohorte.statsprev,
          false
        )
      }
      cohorte.css = { Postulantes: "", Matriculados: "", Equivalentes: "" }
      // Calculamos el nombre para coordinadora de admisión
      cohorte.CoordinadoraAdmision = cohorte.usuario_coordinador_admision
      if (
        cohorte.CoordinadoraAdmision === undefined ||
        cohorte.CoordinadoraAdmision === null ||
        cohorte.CoordinadoraAdmision === "undefined" ||
        cohorte.CoordinadoraAdmision === "null" ||
        cohorte.CoordinadoraAdmision === ""
      ) {
        cohorte.CoordinadoraAdmision = "Sin definir"
      }
      // Calculamos el nombre para coordinadora de programa
      cohorte.CoordinadoraPrograma = cohorte.coordinador_academico
      if (
        cohorte.CoordinadoraPrograma === undefined ||
        cohorte.CoordinadoraPrograma === null ||
        cohorte.CoordinadoraPrograma === "undefined" ||
        cohorte.CoordinadoraPrograma === "null" ||
        cohorte.CoordinadoraPrograma === ""
      ) {
        cohorte.CoordinadoraPrograma = "Sin definir"
      }
      this.actualizaCss(cohorte)
      // Stats a calcular
      let statsNames = ["Stats", "StatsLw", "StatsPrev"]
      // Inicializamos total por facultad
      this.totalFacultad[facultad.nombrecorto] =
        this.totalFacultad[facultad.nombrecorto] ||
        this.estadisticaVacia(cohorte)
      // Recorremos las unidades de venta del cohorte para incializar la estadística
      cohorte.unidadesventa.forEach((uv) => {
        let idx = uv + "-" + facultad.nombrecorto
        // Inicializar stats por UV
        this.totalUnidadventa[uv] =
          this.totalUnidadventa[uv] || this.estadisticaVacia(cohorte)
        // Inicializar stats por UV y Facultad
        this.totalUVF[idx] =
          this.totalUVF[idx] || this.estadisticaVacia(cohorte)
        // Inicializar stats por UV y Facultad y filtro coordinadora admisión
        this.totalUVF[idx].coordinadorasadmision =
          this.totalUVF[idx].coordinadorasadmision || {}
        this.totalUVF[idx].coordinadorasadmision[cohorte.CoordinadoraAdmision] =
          this.totalUVF[idx].coordinadorasadmision[
            cohorte.CoordinadoraAdmision
          ] || this.estadisticaVacia(cohorte)
        // Inicializar stats por UV y Facultad y filtro coordinadora admisión
        this.totalUVF[idx].coordinadorasprogramas =
          this.totalUVF[idx].coordinadorasprogramas || {}
        this.totalUVF[idx].coordinadorasprogramas[
          cohorte.CoordinadoraPrograma
        ] =
          this.totalUVF[idx].coordinadorasprogramas[
            cohorte.CoordinadoraPrograma
          ] || this.estadisticaVacia(cohorte)
      })
      // Por cada stat (hoy, semana pasada y período anterior)
      statsNames.forEach((stat) => {
        // Primero filtramos si el cohorte tiene el stat a calcular, si no lo ignoramos
        if (!cohorte[stat]) {
          return
        }
        // Guardamos estadísticas por cada unidad de venta a la que pertenece el cohorte
        cohorte.unidadesventa.forEach((uv) => {
          let idx = uv + "-" + facultad.nombrecorto
          // Total Unidad de Venta
          this.totalUnidadventa[uv][stat] = UAIStatsCohorte.sumaStats(
            this.totalUnidadventa[uv][stat],
            cohorte[stat],
            this.nombrescortos
          )
          // Total Unidad de Venta y Facultad
          this.totalUVF[idx][stat] = UAIStatsCohorte.sumaStats(
            this.totalUVF[idx][stat],
            cohorte[stat],
            this.nombrescortos
          )
          // Total coordinadora de admisión dentro de Unidad de Venta y Facultad
          this.totalUVF[idx].coordinadorasadmision[
            cohorte.CoordinadoraAdmision
          ][stat] = UAIStatsCohorte.sumaStats(
            this.totalUVF[idx].coordinadorasadmision[
              cohorte.CoordinadoraAdmision
            ][stat],
            cohorte[stat],
            this.nombrescortos
          )
          // Total coordinadora de admisión dentro de Unidad de Venta y Facultad
          this.totalUVF[idx].coordinadorasprogramas[
            cohorte.CoordinadoraPrograma
          ][stat] = UAIStatsCohorte.sumaStats(
            this.totalUVF[idx].coordinadorasprogramas[
              cohorte.CoordinadoraPrograma
            ][stat],
            cohorte[stat],
            this.nombrescortos
          )
        })
        // Totales UAI y Facultad fuera del loop de Unidades de Venta o sumaremos el cohorte dos veces
        // Total UAI
        this.totalUAI[stat] = UAIStatsCohorte.sumaStats(
          this.totalUAI[stat],
          cohorte[stat],
          this.nombrescortos
        )
        // Total Facultad
        this.totalFacultad[facultad.nombrecorto][
          stat
        ] = UAIStatsCohorte.sumaStats(
          this.totalFacultad[facultad.nombrecorto][stat],
          cohorte[stat],
          this.nombrescortos
        )
      })
      // Guardamos el nombre corto ya procesado, para evitar duplicar visitas a un URL
      if (
        this.nombrescortos.indexOf(
          cohorte.año_inicio + "-" + cohorte.nombrecorto
        ) < 0
      ) {
        this.nombrescortos.push(cohorte.año_inicio + "-" + cohorte.nombrecorto)
      }
    }

    // Progreso en 100%
    if (typeof callbackProgress === "function") {
      callbackProgress(100)
    }

    this.cohortes = cohortesinfo
  }

  /**
   *
   * @param {*} cohorte
   * @param {*} usuario
   * @returns
   */
  descartarCohorte(cohorte, usuario) {
    return UAI.cohorteNoVisibleReporteMatriculados(cohorte, usuario)
  }
  updateBenchmark(cohorteid, benchmarkid) {
    let cohorte = this.cohortes.find(function (element) {
      return element.id === cohorteid
    })
    let cohortebenchmark = this.cohortes.find(function (element) {
      return element.id === benchmarkid
    })
    if (cohorte === undefined) {
      console.log(
        "Error! No pude cambiar benchmark en estadísticas. Cohorte inválido " +
          cohorteid
      )
      return
    }
    if (cohortebenchmark === undefined) {
      console.log(
        "Error! No pude cambiar benchmark en estadísticas. Cohorte benchmark inválido " +
          benchmarkid
      )
      return
    }
    let cohorteidx = this.cohortes.indexOf(cohorte)
    let cohortebenchmarkidx = this.cohortes.indexOf(cohortebenchmark)
    if (cohorte.StatsPrev !== null) {
      console.log(
        "Error! El cohorte ya tenía benchmark. No puede ser cambiado desde esta interfaz " +
          cohorteid
      )
      return
    }
    cohorte.StatsPrev = cohortebenchmark.StatsPrev
    cohorte.programaid_anterior = cohortebenchmark.ProgramaId
    cohorte.BenchmarkNombre = cohortebenchmark.Nombre
    cohorte.BenchmarkFechaInicio = cohortebenchmark.FechaInicio
    this.actualizaCss(cohorte)
    if (cohorteidx >= 0) {
      this.cohortes[cohorteidx] = cohorte
    } else {
      console.log("Índice de cohorte inválido:" + cohorteidx)
    }
    if (cohortebenchmarkidx >= 0) {
      this.cohortes.splice(cohortebenchmarkidx, 1)
    }
  }
  actualizaCss(cohorte, periodo) {
    let benchmarkInvalido =
      cohorte &&
      cohorte.Periodo &&
      cohorte.benchmarkinfo &&
      cohorte.benchmarkinfo.año_inicio !== this.periodoant

    let stats = cohorte.Stats
    let statsprev = cohorte.StatsPrev
    if (statsprev && benchmarkInvalido) {
      cohorte.css.Postulantes = "text-danger"
      cohorte.css.Matriculados = ""
      cohorte.css.Equivalentes = ""
      cohorte.css.Meta = ""
    } else if (
      stats !== null &&
      statsprev !== null &&
      stats !== undefined &&
      statsprev !== undefined
    ) {
      cohorte.css.Postulantes = this.calculaCss(
        stats.Postulantes,
        statsprev.Postulantes
      )
      cohorte.css.Matriculados = this.calculaCss(
        stats.Matriculados,
        statsprev.Matriculados
      )
      cohorte.css.Equivalentes = this.calculaCss(
        stats.Equivalentes,
        statsprev.Equivalentes
      )
      cohorte.css.Meta = this.calculaCssMeta(
        stats.Equivalentes,
        cohorte.meta,
        cohorte.fecha_inicio
      )
    }
  }
  calculaCss(current, prev) {
    let pct = prev > 0 ? (current - prev) / prev : 0
    if (pct >= 0) {
      return "alert-success"
    } else if (pct < -0.1) {
      return "alert-danger"
    } else {
      return "alert-warning"
    }
  }
  calculaCssMeta(current, prev, startdate) {
    let today = new Date()
    startdate = parseISO(startdate)
    let minimumDateForGoal = sub(startdate, { months: 1 })
    if (today < minimumDateForGoal) {
      return ""
    }
    let pct = prev > 0 ? (current - prev) / prev : 0
    if (pct >= 0) {
      return "alert-success"
    } else if (pct < -0.1) {
      return "alert-danger"
    } else {
      return "alert-warning"
    }
  }
}

export default UAIStats
